import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { TaskListDto } from '@tpa/api';

@Component({
  selector: 'tpa-task',
  templateUrl: 'task.component.html',
  styleUrls: ['./task.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TaskComponent  {
  @Input() task: TaskListDto;

  @Output() completeClick: EventEmitter<number> = new EventEmitter<number>();

  completBtnclick(id: number) {
    this.completeClick.emit(id);
  }

}
